function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM7.20106 12.4236H10.6004V22.6372H7.20106V12.4236ZM10.8242 9.26419C10.8021 8.26275 10.086 7.5 8.92307 7.5C7.76018 7.5 6.99993 8.26275 6.99993 9.26419C6.99993 10.2449 7.73771 11.0296 8.87895 11.0296H8.90067C10.086 11.0296 10.8242 10.2449 10.8242 9.26419ZM18.9457 12.1838C21.1826 12.1838 22.8596 13.6439 22.8596 16.7811L22.8594 22.6372H19.4603V17.173C19.4603 15.8004 18.9683 14.8639 17.7378 14.8639C16.7986 14.8639 16.2393 15.4953 15.9936 16.1051C15.9037 16.3236 15.8816 16.6281 15.8816 16.9334V22.6375H12.4819C12.4819 22.6375 12.5267 13.3823 12.4819 12.4239H15.8816V13.8706C16.3328 13.1751 17.1409 12.1838 18.9457 12.1838Z",
  fill: "white"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.e5575d10.svg";
export { ForwardRef as ReactComponent };